import React from "react";
import {Config} from "../Config";

export var monthName = ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."];
export var monthNameEn = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export var monthFullName = ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"];
export var monthFullNameEn = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export var dayName = ["อ.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
export var dayNameEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export var dayFullName = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
export var dayFullNameEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export var validateNumber = /^[0-9]*$/;
export var englishCheck = /^[A-Za-z0-9_]*$/;
//export var validateEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export var validateEmail = /\S+@\S+\.\S+/;
export var strengthPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}$/;
export var randomString = Math.random().toString(36).slice(2, 7);
export var random5Number = Math.floor(Math.random()*90000) + 10000;

export var slugString = (str) => {
    return str.replace(/[^a-zA-Z0-9ก-๙-]+/g,'-');
};

export var passwordAlert = (lang) => {
    if(lang === 'en') {
        return 'Password must be at least 8 characters long, containing a mix of upper/lowercase letters, numbers, and special characters is !@#$%^&*';
    }
    else {
        return 'รหัสผ่านต้องเป็นตัวอักษร 8 ตัวขึ้นไป ประกอบไปด้วย ภาษาอังกฤษ พิมพ์เล็ก/ใหญ่ ตัวเลข และอักขระพิเศษ คือ !@#$%^&*  ผสมกัน';
    }
};

export const MEMBER_SUSPENDED_HOUR = 24;
export const MEMBER_SUSPENDED_FAILED = 20;
export const MEMBER_LOGIN_FAILED = 3;

//login token
export const LOCAL_STORAGE_KEY = "ncsaMemberTokens";
export const HOURS_EXPIRE_LOGIN = 24;

export var dateTime = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return <>{day}/{month}/{year}<span className="small d-block text-muted">{hour}:{minute}</span></>;
    }
    else {
        return '';
    }
};

export var dateDMY = (dateTimeUTC, lang = 'th') => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();

        let monthName = lang === 'en' ? monthFullNameEn[month]:monthFullName[month];
        let yearName = lang === 'en' ? year:year + 543;

        return <>{day} {monthName} {yearName}</>;
    }
    else {
        return '';
    }
};

export var dateDM = (dateTimeUTC, lang = 'th') => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();

        let month_Name = lang === 'en' ? monthNameEn[month]:monthName[month];
        let yearName = lang === 'en' ? year:year + 543;

        return <>{day} {month_Name}</>;
    }
    else {
        return '';
    }
};

export var dateTimeDMY = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        day = (day < 10 ? '0':'') + day;

        return  day + '/' + month + '/' + year;
    }
    else {
        return '';
    }
};

export var dateTimeYMD = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        day = (day < 10 ? '0':'') + day;

        return year + '-' + month + '-' + day;
    }
    else {
        return '';
    }
};

export var dateTimeYMDHI = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        day = (day < 10 ? '0':'') + day;
        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
    }
    else {
        return '';
    }
};

export var dateTimeText = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        day = (day < 10 ? '0':'') + day;
        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return day + '/' + month + '/' + year + ' ' + hour + ':' + minute;
    }
    else {
        return '';
    }
};

export function numberWithCommas(x) {
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
        x = x.replace(pattern, "$1,$2");
    return x;
}

export var encodeItem = (json) => {
    return window.btoa(encodeURIComponent(JSON.stringify(json)));
};
export var decodeItem = (encodeStr) => {
    let str = decodeURIComponent(window.atob(encodeStr));
    return JSON.parse(str);
};

// --------------------
export const MEMBER_TYPE_REASEARCHER = 1;
export const MEMBER_TYPE_ENTREPRENEUR = 2;
export const MEMBER_DEPARTMENT_YES = 1;
export const MEMBER_DEPARTMENT_NO = 2;
export const MEMBER_RESEARCH_TYPE_BASIC = 1;
export const MEMBER_RESEARCH_TYPE_APPLIED = 2;
export async function getMemberType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": MEMBER_TYPE_REASEARCHER,
                "title": "นักวิจัย",
            },
            {
                "id": MEMBER_TYPE_ENTREPRENEUR,
                "title": "ผู้ประกอบการ/หน่วยงาน",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export async function getDepartmentType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": MEMBER_DEPARTMENT_YES,
                "title": "ระบุสังกัด",
            },
            {
                "id": MEMBER_DEPARTMENT_NO,
                "title": "ไม่ระบุสังกัด",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export async function getResearchType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": MEMBER_RESEARCH_TYPE_BASIC,
                "title": "การวิจัยพื้นฐาน (Basic Research)",
            },
            {
                "id": MEMBER_RESEARCH_TYPE_APPLIED,
                "title": "การวิจัยประยุกต์ (Applied Research)",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_STATUS_DRAFT = 1;
export const PROPOSAL_STATUS_OFFER = 2;
export const PROPOSAL_STATUS_ACCEPT = 21;
export const PROPOSAL_STATUS_INPROGRESS = 3;
export const PROPOSAL_STATUS_APPROVE = 4;
export const PROPOSAL_STATUS_EDIT = 5;
export const PROPOSAL_STATUS_UPDATE = 51;
export const PROPOSAL_STATUS_REJECT = 6;
export const PROPOSAL_STATUS_CLOSE = 99;
export async function getProposalStatus() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_STATUS_DRAFT,
                "title": "ร่าง",
                "title_en": "Draft"
            },
            {
                "id": PROPOSAL_STATUS_ACCEPT,
                "title": "รับพิจารณา",
                "title_en": "Offer"
            },
            {
                "id": PROPOSAL_STATUS_OFFER,
                "title": "ส่งพิจารณา",
                "title_en": "Offer"
            },
            {
                "id": PROPOSAL_STATUS_EDIT,
                "title": "ส่งแก้ไข",
                "title_en": "Send Edit"
            },
            {
                "id": PROPOSAL_STATUS_UPDATE,
                "title": "อัพเดต(แก้ไข)",
                "title_en": "Update"
            },
            {
                "id": PROPOSAL_STATUS_REJECT,
                "title": "ปฏิเสธ",
                "title_en": "Reject"
            },
            {
                "id": PROPOSAL_STATUS_APPROVE,
                "title": "อนุมัติ",
                "title_en": "Approve"
            },
            {
                "id": PROPOSAL_STATUS_INPROGRESS,
                "title": "อยู่ระหว่างดำเนินการ",
                "title_en": "In Progress"
            },
            {
                "id": PROPOSAL_STATUS_CLOSE,
                "title": "ปิดโครงการ",
                "title_en": "Close"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export function proposalStatusColor(statusId) {
    switch (statusId) {
        case PROPOSAL_STATUS_DRAFT:
            return 'bg-secondary';
        case PROPOSAL_STATUS_OFFER:
        case PROPOSAL_STATUS_INPROGRESS:
            return 'bg-warning';
        case PROPOSAL_STATUS_ACCEPT:
        case PROPOSAL_STATUS_APPROVE:
            return 'bg-success';
        case PROPOSAL_STATUS_EDIT:
            return 'bg-danger';
        case PROPOSAL_STATUS_UPDATE:
            return 'bg-primary';
        case PROPOSAL_STATUS_REJECT:
        case PROPOSAL_STATUS_CLOSE:
            return 'bg-dark';
        default:
            return 'bg-secondary';
    }
}

// --------------------
export const REPORT_RESULT_OFFER = 2;
export const REPORT_RESULT_ACCEPT = 21;
export const REPORT_RESULT_INPROGRESS = 3;
export const REPORT_RESULT_APPROVE = 4;
export const REPORT_RESULT_EDIT = 5;
export const REPORT_RESULT_UPDATE = 51;
export async function getResultStatus() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": REPORT_RESULT_OFFER,
                "title": "ส่งพิจารณา",
                "title_en": "Offer"
            },
            {
                "id": REPORT_RESULT_ACCEPT,
                "title": "รับพิจารณา",
                "title_en": "Offer"
            },
            {
                "id": REPORT_RESULT_INPROGRESS,
                "title": "อยู่ระหว่างดำเนินการ",
                "title_en": "In Progress"
            },
            {
                "id": REPORT_RESULT_APPROVE,
                "title": "อนุมัติ",
                "title_en": "Approve"
            },
            {
                "id": REPORT_RESULT_EDIT,
                "title": "ส่งแก้ไข",
                "title_en": "Send Edit"
            },
            {
                "id": REPORT_RESULT_UPDATE,
                "title": "อัพเดต(แก้ไข)",
                "title_en": "Update"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export function resultStatusColor(statusId) {
    switch (statusId) {
        case REPORT_RESULT_OFFER:
        case REPORT_RESULT_INPROGRESS:
            return 'bg-warning';
        case REPORT_RESULT_ACCEPT:
        case REPORT_RESULT_APPROVE:
            return 'bg-success';
        case REPORT_RESULT_EDIT:
            return 'bg-danger';
        case REPORT_RESULT_UPDATE:
            return 'bg-primary';
        default:
            return 'bg-secondary';
    }
}

// --------------------
export const PROJECT_TYPE_MAIN = 1;
export const PROJECT_TYPE_SET = 2;
export async function getProjectType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROJECT_TYPE_MAIN,
                "title": "โครงการวิจัย",
            },
            {
                "id": PROJECT_TYPE_SET,
                "title": "ชุดโครงการวิจัย",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROJECT_RESEARCH_TYPE_NEW = 1;
export const PROJECT_RESEARCH_TYPE_CONTINUE = 2;
export async function getProjectResearchType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROJECT_RESEARCH_TYPE_NEW,
                "title": "โครงการใหม",
            },
            {
                "id": PROJECT_RESEARCH_TYPE_CONTINUE,
                "title": "โครงการต่อเนื่อง",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const REQUEST_OTHER_NO = 1;
export const REQUEST_OTHER_YES = 2;
export async function getRequestOther() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": REQUEST_OTHER_NO,
                "title": "ไม่มีการยื่นเสนอ",
            },
            {
                "id": REQUEST_OTHER_YES,
                "title": "มีการย่ืนเสนอ",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPERTY_CHECK_NOCHECK = 1;
export const PROPERTY_CHECK_NOTFOUND = 2;
export const PROPERTY_CHECK_FOUND = 3;
export async function getPropertyChecking() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPERTY_CHECK_NOCHECK,
                "title": "ไม่มีการตรวจสอบทรัพย์สินทางปัญญา และ/หรือ สิทธิบัตรที่เกี่ยวข้อง",
            },
            {
                "id": PROPERTY_CHECK_NOTFOUND,
                "title": "ตรวจสอบทรัพย์สินทางปัญญาแล้ว ไม่มีทรัพย์สินทางปัญญา และ/หรือ สิทธิบัตรที่เกี่ยวข้อง",
            },
            {
                "id": PROPERTY_CHECK_FOUND,
                "title": "ตรวจสอบทรัพย์สินทางปัญญาแล้ว มีทรัพย์สินทางปัญญา และ/หรือ สิทธิบัตรที่เกี่ยวข้อง",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_OUTPUT_ACADEMIC = 1;
export const PROPOSAL_OUTPUT_SOCIAL = 2;
export const PROPOSAL_OUTPUT_POLICY = 3;
export const PROPOSAL_OUTPUT_ECONOMIC = 4;
export async function getProposalOutput() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_OUTPUT_ACADEMIC,
                "title": "ด้านวิชาการ",
                "title_en": "Academic"
            },
            {
                "id": PROPOSAL_OUTPUT_SOCIAL,
                "title": "ด้านสังคม",
                "title_en": "Social"
            },
            {
                "id": PROPOSAL_OUTPUT_POLICY,
                "title": "ด้านนโยบาย",
                "title_en": "Policy"
            },
            {
                "id": PROPOSAL_OUTPUT_ECONOMIC,
                "title": "ด้านเศรษฐกิจ",
                "title_en": "Economic"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

export const PROPOSAL_OUTPUT_SUB_PUBLIC = 1;
export const PROPOSAL_OUTPUT_SUB_COMMUNITY = 2;
export const PROPOSAL_OUTPUT_SUB_ENVIRONMENTAL = 3;
export async function getProposalOutputSub() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_OUTPUT_SUB_PUBLIC,
                "title": "ด้านสาธารณะ",
                "title_en": "Public"
            },
            {
                "id": PROPOSAL_OUTPUT_SUB_COMMUNITY,
                "title": "ด้านชุมชนและพื้นที่",
                "title_en": "Community and area"
            },
            {
                "id": PROPOSAL_OUTPUT_SUB_ENVIRONMENTAL,
                "title": "ด้านสิ่งแวดล้อม",
                "title_en": "Environmental"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_AREA_DOMESTIC = 1;
export const PROPOSAL_AREA_ABROAD = 2;
export async function getAreaType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_AREA_DOMESTIC,
                "title": "ในประเทศ",
                "title_en": "Domestic"
            },
            {
                "id": PROPOSAL_AREA_ABROAD,
                "title": "ต่างประเทศ",
                "title_en": "Abroad"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_TARGET_USER_GOVERNMENT = 1;
export const PROPOSAL_TARGET_USER_PRIVATE = 2;
export const PROPOSAL_TARGET_USER_ENTERPRISE = 3;
export const PROPOSAL_TARGET_USER_INDIVIDUAL = 4;
export const PROPOSAL_TARGET_USER_COMMUNITY = 5;
export const PROPOSAL_TARGET_USER_PEOPLE = 6;
export const PROPOSAL_TARGET_USER_OTHER = 7;
export async function getTargetUser() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_TARGET_USER_GOVERNMENT,
                "title": "ภาครัฐ (หน่วยงาน)",
                "title_en": "Government (agencies)"
            },
            {
                "id": PROPOSAL_TARGET_USER_PRIVATE,
                "title": "ภาคเอกชน (เช่น บริษัทขนาดใหญ่ / บริษัทขนาดกลางและขนาดเล็ก/ห้างหุ้นส่วน/กลุ่มกิจการเพื่อสังคม)",
                "title_en": "Private sector (e.g. large companies/medium and small companies/partnerships/social enterprises)"
            },
            {
                "id": PROPOSAL_TARGET_USER_ENTERPRISE,
                "title": "วิสาหกิจชุมชน /สหกรณ์",
                "title_en": "Community enterprises/cooperatives"
            },
            {
                "id": PROPOSAL_TARGET_USER_INDIVIDUAL,
                "title": "ผู้ประกอบการระดับบุคคล/ครัวเรือน",
                "title_en": "Individual/Household Entrepreneurs"
            },
            {
                "id": PROPOSAL_TARGET_USER_COMMUNITY,
                "title": "ชุมชน",
                "title_en": "Community"
            },
            {
                "id": PROPOSAL_TARGET_USER_PEOPLE,
                "title": "ประชาชนทั่วไป",
                "title_en": "General public"
            },
            {
                "id": PROPOSAL_TARGET_USER_OTHER,
                "title": "อื่นๆ โปรดระบุ",
                "title_en": "Other"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_TARGET_BENEFIT_GOVERNMENT = 1;
export const PROPOSAL_TARGET_BENEFIT_PRIVATE = 2;
export const PROPOSAL_TARGET_BENEFIT_ENTERPRISES = 3;
export const PROPOSAL_TARGET_BENEFIT_INDIVIDUAL = 4;
export const PROPOSAL_TARGET_BENEFIT_COMMUNITY = 5;
export const PROPOSAL_TARGET_BENEFIT_PEOPLE = 6;
export const PROPOSAL_TARGET_BENEFIT_OTHER = 7;
export async function getTargetBenefit() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_TARGET_BENEFIT_GOVERNMENT,
                "title": "ประเทศ / ภาครัฐ (หน่วยงาน) ",
                "title_en": "Country / Government (Agency)",
                "example": "เช่น ประหยัดงบประมาณ ลดการนำเข้า เพิ่มการส่งออก",
                "example_en": "Such as saving budget, reducing imports, increasing exports"
            },
            {
                "id": PROPOSAL_TARGET_BENEFIT_PRIVATE,
                "title": "ภาคเอกชน (เช่น บริษัทขนาดใหญ่ / บริษัทขนาดกลางและขนาดเล็ก/ห้างหุ้นส่วน/กลุ่มกิจการเพื่อสังคม)",
                "title_en": "Private sector (e.g. large companies/medium and small companies/partnerships/social enterprises)",
                "example": "เช่น เพิ่มรายได้ ลดต้นทุน ประหยัดค่าใช้จ่าย เพิ่มศักยภาพหรือผลิตภาพ",
                "example_en": "Such as increasing income, reducing costs, saving expenses, increasing potential or productivity"
            },
            {
                "id": PROPOSAL_TARGET_BENEFIT_ENTERPRISES,
                "title": "วิสาหกิจชุมชน /สหกรณ์ / กลุ่มผู้ประกอบการในพื้นที่",
                "title_en": "Community enterprises / cooperatives / local entrepreneur groups",
                "example": "เช่น เพิ่มรายได้ เพิ่มทุนทางสังคม เพิ่มทุนทางเศรษฐกิจให้ชุมชน (เช่น เงินทุนสะสม อุปกรณ์ โครงสร้างพื้นฐานทางการผลิตของชุมชน) เพิ่มศักยภาพผู้ประกอบการ หรือ กำลังแรงงานในชุมชน",
                "example_en": "For example, increasing income, increasing social capital, increasing economic capital for the community (e.g. accumulated capital, equipment, production infrastructure of the community), increasing the potential of entrepreneurs or labor force in the community"
            },
            {
                "id": PROPOSAL_TARGET_BENEFIT_INDIVIDUAL,
                "title": "ผู้ประกอบการระดับบุคคล/ครัวเรือน (เช่น เกษตรกร)",
                "title_en": "Individual/household entrepreneurs (e.g. farmers)",
                "example": "เช่น เพิ่มรายได้ เพิ่มทุนทางสังคม เพิ่มทุนทางเศรษฐกิจให้ชุมชน (เช่น เงินทุนสะสม อุปกรณ์ โครงสร้างพื้นฐานทางการผลิตของชุมชน) เพิ่มศักยภาพผู้ประกอบการ หรือ กำลังแรงงานในชุมชน",
                "example_en": "For example, increasing income, increasing social capital, increasing economic capital for the community (e.g. accumulated capital, equipment, production infrastructure of the community), increasing the potential of entrepreneurs or labor force in the community"
            },
            {
                "id": PROPOSAL_TARGET_BENEFIT_COMMUNITY,
                "title": "ชุมชน (กลุ่มคน)",
                "title_en": "Community (group of people)",
                "example": "เช่น ลดการสูญเสียทรัพยากรของชุมชน ลดมลพิษ",
                "example_en": "Such as reducing the loss of community resources, reducing pollution"
            },
            {
                "id": PROPOSAL_TARGET_BENEFIT_PEOPLE,
                "title": "ประชาชนทั่วไป ปัจเจกบุคคล หรือ ครัวเรือน",
                "title_en": "General public, individuals or households",
                "example": "เช่น ลดค่าใช้จ่ายด้านสุขภาพ ลดอัตราการเสียชีวิต อายุขัยเพิ่มขึ้น คุณภาพชีวิตดีขึ้น",
                "example_en": "Such as reducing health care costs, reducing mortality rates, increasing life expectancy, and improving quality of life"
            },
            {
                "id": PROPOSAL_TARGET_BENEFIT_OTHER,
                "title": "อื่นๆ โปรดระบุ",
                "title_en": "Other, please specify",
                "example": "",
                "example_en": ""
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_PROCESS_PUBLICATION = 1;
export const PROPOSAL_PROCESS_TOOL = 2;
export const PROPOSAL_PROCESS_INTELLECTUAL = 3;
export const PROPOSAL_PROCESS_TECHNOLOGY = 4;
export const PROPOSAL_PROCESS_PRODUCT = 5;
export const PROPOSAL_PROCESS_KNOWLEDGE = 6;
export const PROPOSAL_PROCESS_POLICY = 7;
export const PROPOSAL_PROCESS_ENGAGEMENT = 8;
export const PROPOSAL_PROCESS_FURTHER = 9;
export const PROPOSAL_PROCESS_COLLABORATION = 10;
export const PROPOSAL_PROCESS_DESTINATION = 11;
export const PROPOSAL_PROCESS_AWARD = 12;
export const PROPOSAL_PROCESS_FACILITY = 13;
export async function getProposalProcess() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_PROCESS_PUBLICATION,
                "title": "ผลงานตีพิมพ์ (Publications)",
                "title_en": "Publications"
            },
            {
                "id": PROPOSAL_PROCESS_TOOL,
                "title": "เครื่องมือหรือระเบียบวิธีการวิจัย/ฐานข้อมูลหรือแบบจำลองวิจัยที่ค้นพบใหม่ (Research tools or methods/Research databases or models)",
                "title_en": "Research tools or methods/Research databases or models"
            },
            {
                "id": PROPOSAL_PROCESS_INTELLECTUAL,
                "title": "ทรัพย์สินทางปัญญา การขึ้นทะเบียนพันธุ์พืชและพันธุ์สัตว์ หรือการอนุญาตให้ใช้สิทธิ (Intellectual property, Registered Plants Varieties and Animals Breeding or Licensing)",
                "title_en": "Intellectual property, Registered Plants Varieties and Animals Breeding or Licensing"
            },
            {
                "id": PROPOSAL_PROCESS_TECHNOLOGY,
                "title": "การถ่ายทอดเทคโนโลยี (Technology Transfer)",
                "title_en": "Technology Transfer"
            },
            {
                "id": PROPOSAL_PROCESS_PRODUCT,
                "title": "ผลิตภัณฑ์และกระบวนการ บริการ และการรับรองมาตรฐานใหม่ (New Products/Processes, New Services and New Standard Assurances)",
                "title_en": "New Products/Processes, New Services and New Standard Assurances"
            },
            {
                "id": PROPOSAL_PROCESS_KNOWLEDGE,
                "title": "การจัดการความรู้และแพลตฟอร์มเพื่อถ่ายทอดเทคโนโลยี และการเตรียมความพร้อมให้ผู้รับถ่ายทอดเทคโนโลยี (Knowledge and Platform management for Technology transfer and Empowerment for Technology transfer)",
                "title_en": "Knowledge and Platform management for Technology transfer and Empowerment for Technology transfer"
            },
            {
                "id": PROPOSAL_PROCESS_POLICY,
                "title": "การใช้ประโยชน์เชิงนโยบาย (แนวปฏิบัติ/มาตรการ/แผน/กฎระเบียบ) (Policy Utilization (Guideline/Measure/Plan/Regulations))",
                "title_en": "Policy Utilization (Guideline/Measure/Plan/Regulations)"
            },
            {
                "id": PROPOSAL_PROCESS_ENGAGEMENT,
                "title": "กิจกรรมสร้างการมีส่วนร่วม (Engagement activities)",
                "title_en": "Engagement activities"
            },
            {
                "id": PROPOSAL_PROCESS_FURTHER,
                "title": "ทุนวิจัยต่อยอด (Further funding)",
                "title_en": "Further funding"
            },
            {
                "id": PROPOSAL_PROCESS_COLLABORATION,
                "title": "ความร่วมมือหรือหุ้นส่วนความร่วมมือ (Collaborations and partnerships)",
                "title_en": "Collaborations and partnerships"
            },
            {
                "id": PROPOSAL_PROCESS_DESTINATION,
                "title": "ความก้าวหน้าในวิชาชีพของบุคลากรด้านวิทยาศาสตร์วิจัยและนวัตกรรม (Next destination)",
                "title_en": "Next destination"
            },
            {
                "id": PROPOSAL_PROCESS_AWARD,
                "title": "รางวัลและการยอมรับ (Awards and recognition)",
                "title_en": "Awards and recognition"
            },
            {
                "id": PROPOSAL_PROCESS_FACILITY,
                "title": "เครื่องมือ อุปกรณ์ ห้องวิจัยและโครงสร้างพื้นฐาน  ที่นักวิจัยพัฒนาขึ้น หรือได้รับงบประมาณ มีการใช้ประโยชน์ต่อในวงกว้าง (Use of facilities and resources)",
                "title_en": "Use of facilities and resources"
            },
            {
                "id": PROPOSAL_PROCESS_FACILITY,
                "title": "เครื่องมือ อุปกรณ์ ห้องวิจัยและโครงสร้างพื้นฐาน  ที่นักวิจัยพัฒนาขึ้น หรือได้รับงบประมาณ มีการใช้ประโยชน์ต่อในวงกว้าง (Use of facilities and resources)",
                "title_en": "Use of facilities and resources"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_EXPENSES_PERSONNEL = 1;
export const PROPOSAL_EXPENSES_OPERATING = 2;
export const PROPOSAL_EXPENSES_INVESTMENT = 3;
export async function getExpensesType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_EXPENSES_PERSONNEL,
                "title": "งบบุคลากร",
                "title_en": "Personnel"
            },
            {
                "id": PROPOSAL_EXPENSES_OPERATING,
                "title": "งบดำเนินงาน",
                "title_en": "Operating"
            },
            {
                "id": PROPOSAL_EXPENSES_INVESTMENT,
                "title": "งบลงทุน",
                "title_en": "Investment"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_EXPENSES_SUB_COMPENSATION = 1;
export const PROPOSAL_EXPENSES_SUB_EXPENSES = 2;
export const PROPOSAL_EXPENSES_SUB_MATERIAL = 3;
export const PROPOSAL_EXPENSES_SUB_UTILITY = 4;
export const PROPOSAL_EXPENSES_SUB_WAGES = 5;
export const PROPOSAL_EXPENSES_SUB_INTERNATIONAL = 6;
export const PROPOSAL_EXPENSES_SUB_INSTITUTIONAL = 7;
export const PROPOSAL_EXPENSES_SUB_EQUIPMENT = 8;
export async function getExpensesSubType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_EXPENSES_SUB_COMPENSATION,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าตอบแทน",
                "title_en": "Compensation"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_EXPENSES,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าใช้สอย",
                "title_en": "Expenses"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_MATERIAL,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าวัสดุ",
                "title_en": "Material"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_UTILITY,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าสาธารณูปโภค",
                "title_en": "Utility"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_WAGES,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าจ้าง",
                "title_en": "Wages"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_INTERNATIONAL,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าเดินทางต่างประเทศ",
                "title_en": "International travel expenses"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_INSTITUTIONAL,
                "typeId": PROPOSAL_EXPENSES_OPERATING,
                "title": "ค่าธรรมเนียมอุดหนุนสถาบัน",
                "title_en": "Institutional Subsidy Fee"
            },
            {
                "id": PROPOSAL_EXPENSES_SUB_EQUIPMENT,
                "typeId": PROPOSAL_EXPENSES_INVESTMENT,
                "title": "ค่าครุภัณฑ์",
                "title_en": "Equipment"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export const PROPOSAL_IMPACT_ECONOMIC = 1;
export const PROPOSAL_IMPACT_SOCIAL = 2;
export const PROPOSAL_IMPACT_ENVIRONMENTAL = 3;
export async function getImpactType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": PROPOSAL_IMPACT_ECONOMIC,
                "title": "ด้านเศรษฐกิจ",
                "title_en": "Economic"
            },
            {
                "id": PROPOSAL_IMPACT_SOCIAL,
                "title": "ด้านสังคม ",
                "title_en": "Social aspect"
            },
            {
                "id": PROPOSAL_IMPACT_ENVIRONMENTAL,
                "title": "ด้านสิ่งแวดล้อม",
                "title_en": "Environmental"
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

// --------------------
export async function getProfile(member) {
    const response = await fetch(Config.apiUrl +'/member/profile', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': member.accessToken
        }
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

// --------------------
export async function getIscedBroad() {
    const response = await fetch(Config.apiUrl +'/isced/list', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getIscedNarrow(iscedBroad) {
    const response = await fetch(Config.apiUrl +'/iscedLv2/list', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            iscedId: iscedBroad
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getIscedDetailed(iscedNarrow) {
    const response = await fetch(Config.apiUrl +'/iscedLv3/list', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            iscedLv2Id: iscedNarrow
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

// --------------------
export async function getOecdMain() {
    const response = await fetch(Config.apiUrl +'/oecd/list', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getOecdSub(oecdMain) {
    const response = await fetch(Config.apiUrl +'/oecdLv2/list', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            oecdId: oecdMain
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getOecdRelation(oecdSub) {
    const response = await fetch(Config.apiUrl +'/oecdLv3/list', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            oecdLv2Id: oecdSub
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getResearcherMember(member) {
    const response = await fetch(Config.apiUrl +'/researcher/viewMember', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': member.accessToken
        }
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getEntrepreneurMember(member) {
    const response = await fetch(Config.apiUrl +'/entrepreneur/viewMember', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': member.accessToken
        }
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export const allowImageExtension = "image/jpg,image/png,image/jpeg";
export const allowFileExtension = "image/jpg,image/png,image/jpeg,application/pdf";
export const allowPdfExtension = "application/pdf";
export const allowSVGExtension = "image/jpg,image/png,image/jpeg,image/svg+xml";
export const maxFileSizeMb = 5;
export var onSelectFile = (e) => {
    if(e && e.target && e.target.files[0]) {
        let KB = e.target.files[0].size;
        let MB = maxFileSizeMb;
        if(KB && (KB/1000000) >= MB) {
            return new Promise((done, err) => {
                e.target.value = '';
                alert('ขนาดไฟล์ต้องไม่เกิน ' + MB + ' MB');
            })
        }
        else {
            return new Promise(resolve => {
                let baseURL = "";
                let reader = new FileReader();
                reader.readAsDataURL(e.target.files[0]);
                reader.onload = () => {
                    baseURL = reader.result;
                    resolve(baseURL);
                };
            });
        }
    }
};